import { IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { sxIconButton } from '../Accessibility/sxProps';
import './styles.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`;

interface PDFViewerProps {
  file: string;
  style?: React.CSSProperties;
}


const PDFViewer: React.FC<PDFViewerProps> = ({ file, style }) => {
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    function updateWidth() {
      if (containerRef.current) {
        const fullWidth = containerRef.current.offsetWidth;
        const maxWidth = 800;
        const calculatedWidth = Math.min(fullWidth, maxWidth);
        setContainerWidth(calculatedWidth);
      }
    }
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const { buttonStyleAccessibility } = useAccessibility();
  const handlePrevious = () => setPageNumber((p) => Math.max(1, p - 1));
  const handleNext = () => setPageNumber((p) => Math.min(numPages, p + 1));

  const handleOpenPdfInNewTab = () => {
  const base64 = file.replace(/^data:application\/pdf;base64,/, "");
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, "_blank");
};

  return (
    <div className='contract-pdf-viewer-container' style={style} ref={containerRef}>
      <div className='contract-pdf-controls'>
        <div className='contract-pdf-controls'>
          <IconButton sx={sxIconButton} onClick={handlePrevious} disabled={pageNumber <= 1} style={buttonStyleAccessibility}>
            {'<'}
          </IconButton>
          <Typography>
            {pageNumber} / {numPages}
          </Typography>
          <IconButton sx={sxIconButton} onClick={handleNext} disabled={pageNumber >= numPages} style={buttonStyleAccessibility}>
            {'>'}
          </IconButton>
        </div>
      </div>
      <Document
        file={file}
        onLoadSuccess={({ numPages }: { numPages: number }) => setNumPages(numPages)}
        loading="Carregando PDF..."
        error="Erro ao carregar o PDF."
      >
        {containerWidth && (
          <Page
            pageNumber={pageNumber}
            width={containerWidth}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            onClick={handleOpenPdfInNewTab}
            className={'page-canva'}
          />
        )}
      </Document>
    </div>
  );
};

export default PDFViewer;